<latch-dropdown
  class="account-select"
  [data]="sortedAccounts"
  [typeahead]="true"
  placeholder="Search Portfolios"
  [ngModel]="selectedAccount"
  (ngModelChange)="handleChangeAccount($event)">
</latch-dropdown>
